import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPen = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8.09014 20.34L3.56014 20.99C3.48014 21.01 3.41014 21 3.33014 20.99C3.26014 20.97 3.19014 20.93 3.13014 20.87C3.07014 20.82 3.04014 20.75 3.01014 20.67C2.99014 20.6 2.98014 20.52 3.01014 20.44L3.66015 15.91C3.73015 15.39 3.97014 14.92 4.34014 14.55L14.8401 4.06C15.1801 3.72 15.5701 3.46 16.0101 3.28C16.4501 3.1 16.9201 3 17.3901 3C17.8601 3 18.3301 3.09 18.7701 3.28C19.2101 3.46 19.6101 3.73 19.9401 4.06C20.2801 4.39 20.5401 4.79001 20.7201 5.23001C20.9001 5.67001 21.0001 6.13999 21.0001 6.60999C21.0001 7.07999 20.9101 7.54999 20.7201 7.98999C20.5401 8.42999 20.2701 8.83 19.9401 9.16L9.50014 19.66C9.12014 20.04 8.62014 20.27 8.09014 20.34Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10
	}), /* @__PURE__ */ _jsx("path", {
		d: "M17.0298 6.97998L15.5098 8.48996",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round"
	})]
});
export default SvgPen;
